import React, { useEffect, useState } from 'react';
import { Save, Loader2, Palette, Building2 } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { teamsApi } from '../services/creatorApi';
import { toast } from 'sonner';
export function Settings() {
  const {
    currentWorkspace,
    refreshTeams
  } = useWorkspace();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: currentWorkspace.name,
    logoUrl: currentWorkspace.logoUrl || '',
    primaryColor: currentWorkspace.primaryColor || '#2563eb'
  });
  useEffect(() => {
    setForm({
      name: currentWorkspace.name,
      logoUrl: currentWorkspace.logoUrl || '',
      primaryColor: currentWorkspace.primaryColor || '#2563eb'
    });
  }, [currentWorkspace]);
  const handleSave = async () => {
    if (!currentWorkspace.creatorId) {
      toast.error('No team record found — create a team in the Regions module first');
      return;
    }
    setSaving(true);
    try {
      await teamsApi.update(currentWorkspace.creatorId, {
        Team_Name: form.name,
        Logo_URL: form.logoUrl,
        Primary_Color: form.primaryColor
      } as any);
      toast.success('Settings saved');
      await refreshTeams();
    } catch (err) {
      console.error('Failed to save settings:', err);
      toast.error('Failed to save settings');
    } finally {
      setSaving(false);
    }
  };
  return <div className="space-y-6" data-id="element-6020" data-mp="as3c9sk491dd">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-6021" data-mp="ar1oqolwymer">
        <div className="min-w-0" data-id="element-6022" data-mp="5t9w1sdg2w9i">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-6023" data-mp="kr2bkkizrknp">
            Team Settings
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-6024" data-mp="frzf3oh2umrc">
            Configure branding for {currentWorkspace.name}.
          </p>
        </div>
        <button onClick={handleSave} disabled={saving} className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 disabled:opacity-50 whitespace-nowrap flex-shrink-0" data-id="element-6025" data-mp="2mjgpl8if04yu">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" data-id="element-6026" data-mp="3ba4iemfvmlm8" /> : <Save className="h-4 w-4 flex-shrink-0" data-id="element-6027" data-mp="3g8fxbbl13mbb" />}
          <span data-id="element-6028" data-mp="3ga94crzk08ju">Save Changes</span>
        </button>
      </div>

      <div className="space-y-6 max-w-4xl" data-id="element-6029" data-mp="3l8ao7f4t0bwd">
        {/* Branding Section */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 space-y-4" data-id="element-6030" data-mp="3q6vnncc8erjr">
          <div className="flex items-center gap-2 mb-2" data-id="element-6031" data-mp="3u7flki4mpz6y">
            <Building2 className="h-5 w-5 text-gray-400" data-id="element-6032" data-mp="3u5ur0sibeg93" />
            <h3 className="text-lg font-medium text-gray-900" data-id="element-6033" data-mp="2ub6kkwhpybi">Branding</h3>
          </div>
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-6034" data-mp="7smgswqp6au9">
            <div className="sm:col-span-4" data-id="element-6035" data-mp="crpkacr14904">
              <label className="block text-sm font-medium text-gray-700" data-id="element-6036" data-mp="ct0mw98qnapn">
                Team Name
              </label>
              <input type="text" value={form.name} onChange={e => setForm({
              ...form,
              name: e.target.value
            })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-6037" data-mp="hog152anr8ml" />
            </div>
            <div className="sm:col-span-6" data-id="element-6038" data-mp="2kyt249kj6l04">
              <label className="block text-sm font-medium text-gray-700" data-id="element-6039" data-mp="2kxrg5a1z8e3m">
                Logo URL
              </label>
              <input type="url" value={form.logoUrl} onChange={e => setForm({
              ...form,
              logoUrl: e.target.value
            })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="https://..." data-id="element-6040" data-mp="2g0rgphzmu9lh" />
              {form.logoUrl && <div className="mt-2" data-id="element-6041" data-mp="2jf9c44czllhx">
                  <img src={form.logoUrl} alt="Team logo preview" className="h-12 object-contain rounded border border-gray-200 bg-gray-50 p-1" onError={e => {
                ;
                (e.target as HTMLImageElement).style.display = 'none';
              }} data-id="element-6042" data-mp="2ofx7t3c5uqih" />
                </div>}
            </div>
            <div className="sm:col-span-3" data-id="element-6043" data-mp="376y5zp5gii0z">
              <label className="block text-sm font-medium text-gray-700" data-id="element-6044" data-mp="375n45uvknkci">
                Primary Color
              </label>
              <div className="mt-1 flex items-center gap-3" data-id="element-6045" data-mp="2sfo6dt7xiaxk">
                <input type="color" value={form.primaryColor} onChange={e => setForm({
                ...form,
                primaryColor: e.target.value
              })} className="h-9 w-9 rounded border border-gray-300 cursor-pointer flex-shrink-0" data-id="element-6046" data-mp="2xf0usieg7q29" />
                <input type="text" value={form.primaryColor} onChange={e => setForm({
                ...form,
                primaryColor: e.target.value
              })} className="block w-32 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm font-mono" placeholder="#2563eb" data-id="element-6047" data-mp="19ib4ky8hgw5k" />
              </div>
              <div className="mt-3 flex items-center gap-3" data-id="element-6048" data-mp="14l2mexnc4s4b">
                <div className="h-8 px-4 rounded-md flex items-center text-white text-xs font-medium" style={{
                backgroundColor: form.primaryColor
              }} data-id="element-6049" data-mp="10hwhbtbyl6zf">
                  Preview Button
                </div>
                <div className="h-8 w-8 rounded-full flex items-center justify-center text-white text-xs font-bold" style={{
                backgroundColor: form.primaryColor
              }} data-id="element-6050" data-mp="18n6zn63ln637">
                  A
                </div>
                <span className="text-xs text-gray-500" data-id="element-6051" data-mp="1mmgh093jk68r">
                  Used for sidebar accents, active states, and avatars
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Info card */}
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm text-gray-600" data-id="element-6052" data-mp="uv8xxgc7wch2">
          <p data-id="element-6053" data-mp="yvb3i0l2pq1m">
            <strong data-id="element-6054" data-mp="yuriuc41gnjw">Regions</strong> are managed in the{' '}
            <a href="/regions" className="text-blue-600 hover:text-blue-700 underline" data-id="element-6055" data-mp="13o47uncmqwd6">
              Regions
            </a>{' '}
            module.
            <strong className="ml-3" data-id="element-6056" data-mp="b5ykk8zy23m4">Users</strong> are managed in the{' '}
            <a href="/users" className="text-blue-600 hover:text-blue-700 underline" data-id="element-6057" data-mp="3o0p38elkt1w">
              Team Users
            </a>{' '}
            module.
          </p>
        </div>
      </div>
    </div>;
}